<template>
  <app-page-subsection :title="$t('teacher.page.courses_title')">
    <div class="grid gap-12">
      <section
        v-for="course in teacher.courses"
        :key="course.id"
        class="flex flex-col items-start"
        data-cy-course
        :data-cy-course-id="course.id"
      >
        <app-card-link-background
          class="mb-2"
          target="_blank"
          :to="
            course.public
              ? {
                  name: 'courses-slug',
                  params: {
                    slug: course.slug,
                  },
                }
              : undefined
          "
        >
          <h3 class="text-lg font-semibold">
            {{ course.title }}
            <app-icon
              v-if="course.public"
              icon="ph:arrow-circle-up-right"
              :size="20"
            />
          </h3>
        </app-card-link-background>

        <div class="flex flex-wrap items-center gap-2">
          <course-rating-chip
            v-if="course.ratings"
            size="small"
            :total-number-of-ratings="course.ratings.count"
            :value="course.ratings.avg"
          />
          <course-format-chip :format="course.format" size="small" />
        </div>

        <ol class="mt-5 grid max-w-[850px] gap-2">
          <li
            v-for="(outcome, index) in course.outcomes"
            :key="outcome"
            class="flex gap-3"
          >
            <strong>{{ index + 1 }}.</strong>
            <app-text-markdown
              class="inline [&_strong]:font-normal"
              lazy
              :value="outcome"
            />
          </li>
        </ol>
      </section>
    </div>
  </app-page-subsection>
</template>

<script lang="ts" setup>
import type { TeacherPageView } from "~/business-areas/teacher/teacher.model";

defineProps<{
  teacher: TeacherPageView;
}>();
</script>
